import classNames from 'classnames';
import Icon, { Icons } from '../../../Icon/Icon';
import ListItem from '../../../ListItem';

import { t } from '../../../../lang';
import './FileItem.scss';

const FileItem = ({ file, isError, isLoading, bottomSeparator, onDelete }) => {
	const formatFileSize = bytes => {
		if (!bytes) return '0 KB';

		const kb = bytes / 1024;

		if (kb < 1024) {
			return `${Math.round(kb)} KB`;
		}

		const mb = kb / 1024;
		return `${mb.toFixed(1)} MB`;
	};

	// const rightIcon = isLoading ? Icons.LOADING_SPINNER : Icons.TRASH;
	let rightTitle = null;

	if (isLoading) {
		rightTitle = <Icon type={Icons.LOADING_SPINNER} width={24} height={24} />;
	} else {
		rightTitle = <Icon className='FileItem__trash' type={Icons.TRASH} width={24} height={24} onClick={onDelete} />;
	}

	return (
		<ListItem
			className={classNames('FileItem', isError && 'FileItem__error')}
			icon={'DOCUMENT_ICON'}
			iconSize='medium'
			title={file.name}
			description={isError ? <p className='FileItem__error-text'>{t('Error')}</p> : formatFileSize(file.size)}
			rightTitle={rightTitle}
			bottomSeparator={bottomSeparator}
		/>
	);
};

export default FileItem;
